import { AxiosPromise } from 'axios';
import axios from 'axios';
import { IGetDashboardCampus, IGetDashboardInquiry, IGetDashboardMtClinic, IGetDashboardNotice, IGetDashboardPT, IGetDashboardTeacher } from '../models/dashboard.model';

const uri = '/mgmt/dash-board';

export const getDashboardCampus = (): AxiosPromise<IGetDashboardCampus> => {
  return axios.get(`${uri}/operational-status`);
};

export const getDashboardPT = (campusCode: string): AxiosPromise<IGetDashboardPT> => {
  return axios.get(`${uri}/placement-test/${campusCode}`);
};

export const getDashboardTeacher = (campusCode: string): AxiosPromise<IGetDashboardTeacher> => {
  return axios.get(`${uri}/class-status/${campusCode}`);
};

export const getDashboardNotice = (campusCode: string): AxiosPromise<IGetDashboardNotice> => {
  return axios.get(`${uri}/notice-list/${campusCode}`);
};

export const getDashboardInquiry = (campusCode: string): AxiosPromise<IGetDashboardInquiry> => {
  return axios.get(`${uri}/homepage-qna/${campusCode}`);
};

export const getDashboardMtClinic = (campusCode: string, classCode: string): AxiosPromise<IGetDashboardMtClinic> => {
  return axios.get(`${uri}/mt-clinic/${campusCode}/${classCode}`);
};

export const updateExamCounselStatus = (form: FormData): AxiosPromise => {
  return axios.post(`${uri}/mt-clinic/counsel`, form);
};